<template>
  <span>{{ data | toCsv }}</span>
</template>

<script>
export default {
  props: ['data']
}
</script>
